import {
  IconTrendUp, IconBriefcase, IconLock, IconUmbrella,
  IconHeart, IconDollarSign, IconBank, IconFileText, IconScale,
  IconActivity, IconPiggyBank, IconCreditCard,
} from "../components/Icons";


export const mutualFundData = {
  Icon: IconTrendUp,
  title: "Mutual Fund",
  tagline: "Grow your wealth through professionally managed, diversified investment portfolios.",
  intro: [
    "Mutual funds offer a simple and effective way to grow your wealth. By pooling resources from various investors, these funds provide access to a diverse portfolio managed by financial experts.",
    "Whether you're a seasoned investor or just starting, mutual funds cater to all risk appetites and financial goals — from conservative debt funds to high-growth equity funds.",
    "At AVS Financial Services, we assess your risk profile and financial goals before recommending the most suitable fund categories — ensuring your money works as hard as you do.",
  ],
  reasons: [
    { label: "Diversification",         desc: "Spread investments across asset classes, significantly reducing portfolio risk." },
    { label: "Professional Management", desc: "Benefit from the expertise of SEBI-registered fund managers." },
    { label: "Flexibility",             desc: "Choose from equity, debt, hybrid, or sectoral funds based on your goals." },
    { label: "High Liquidity",          desc: "Most open-ended funds settle within 1–3 business days." },
    { label: "Systematic Investment",   desc: "Start a SIP with as little as ₹500/month — discipline builds wealth." },
  ],
  cta: { heading: "Start Your Mutual Fund Journey Today", sub: "Get a personalised fund recommendation tailored to your goals." },
};

export const dematAccountData = {
  Icon: IconBriefcase,
  title: "Demat Account",
  tagline: "Your gateway to hassle-free, paperless investing in the stock market.",
  intro: [
    "A Demat Account allows you to hold shares and securities electronically, eliminating risks associated with physical certificates.",
    "When you open a Demat Account through AVS, you get expert guidance on stock selection, portfolio tracking, and market timing — not just a bare account.",
    "We partner with reputed depository participants to ensure a smooth, quick account opening process with minimum documentation.",
  ],
  reasons: [
    { label: "Safety",             desc: "Eliminate the risk of loss, theft, or damage to physical share certificates." },
    { label: "Convenience",        desc: "Buy, sell, and transfer shares with just a few clicks from anywhere." },
    { label: "Real-Time Tracking", desc: "Monitor your portfolio in real-time with detailed transaction history." },
    { label: "Seamless Trading",   desc: "Linked trading account enables swift and smooth transactions." },
    { label: "Multi-Asset Holding",desc: "Hold equities, bonds, ETFs, and mutual fund units in one account." },
  ],
  cta: { heading: "Open Your Demat Account Today", sub: "Get started in minutes with minimal paperwork. We handle everything end-to-end." },
};

export const corporateFDData = {
  Icon: IconLock,
  title: "Corporate Fixed Deposit",
  tagline: "Earn higher returns than bank FDs with the security of established corporations.",
  intro: [
    "Corporate Fixed Deposits offer attractive, guaranteed returns — typically higher than bank FDs — while maintaining the safety of a predetermined interest rate throughout the tenure.",
    "AVS carefully vets the companies whose FDs we recommend, focusing on strong credit ratings (AA and above) to ensure your capital is as safe as possible.",
    "Whether planning for a short-term goal or a stable income stream, Corporate FDs offer the predictability and peace of mind you need.",
  ],
  reasons: [
    { label: "Higher Returns",     desc: "Corporate FDs typically offer 1–2% higher interest than bank FDs." },
    { label: "Fixed Interest Rate",desc: "Earn a stable and fully predictable income throughout the tenure." },
    { label: "Flexible Tenure",    desc: "Choose from a range of tenures — from 1 year to 5 years." },
    { label: "Credit-Rated Safety",desc: "We recommend only AA/AAA rated corporate FDs for maximum security." },
    { label: "Payout Options",     desc: "Opt for monthly/annual interest payouts or cumulative growth." },
  ],
  cta: { heading: "Secure Your Savings with Corporate FDs", sub: "Talk to us about the best Corporate FD options for your risk profile right now." },
};

export const lifeInsuranceData = {
  Icon: IconUmbrella,
  title: "Life Insurance",
  tagline: "Protect your family's financial future — because love needs a safety net.",
  intro: [
    "Life insurance is a promise to your family that their lives will be protected even in your absence. Every earning individual owes this protection to their loved ones.",
    "At AVS, we help you navigate Term Plans, ULIPs, Endowment Plans, and Whole Life policies to find the best fit for your situation.",
    "We work with leading insurers to provide competitive premiums and robust coverage for your family's goals.",
  ],
  reasons: [
    { label: "Income Replacement", desc: "Replace your income for your family if something unexpected happens." },
    { label: "Loan Coverage",      desc: "Pay off home and car loans, protecting family assets." },
    { label: "Tax Benefits",       desc: "Premiums paid qualify for deductions under Section 80C." },
    { label: "Wealth Creation",    desc: "Certain plans combine insurance with long-term wealth creation." },
    { label: "Customisable Riders",desc: "Add riders for critical illness, accidental death, and disability." },
  ],
  cta: { heading: "Secure Your Family's Future Today", sub: "It's always the right time to protect your loved ones." },
};

export const healthInsuranceData = {
  Icon: IconHeart,
  title: "Health Insurance",
  tagline: "Safeguard your health and wealth against rising medical costs.",
  intro: [
    "Medical costs in India are rising at 15–20% annually. Without adequate health insurance, a single hospitalisation can wipe out years of savings.",
    "AVS helps you choose the right plan — individual, family floater, senior citizen, or top-up coverage — from reputed insurers with high claim settlement ratios.",
    "We guide you through the fine print: sub-limits, co-payments, waiting periods, and network hospitals — so you know exactly what you're covered for.",
  ],
  reasons: [
    { label: "Cashless Hospitalisation", desc: "Avail cashless treatment at thousands of network hospitals across India." },
    { label: "No-Claim Bonus",           desc: "Earn bonus coverage for every claim-free year." },
    { label: "Tax Deduction u/s 80D",    desc: "Premiums qualify for deductions up to ₹1 lakh." },
    { label: "Pre & Post Hospitalisation",desc: "Coverage for expenses before and after hospitalisation." },
    { label: "Day Care Treatments",      desc: "540+ day care procedures covered without 24-hour admission." },
  ],
  cta: { heading: "Don't Let Medical Costs Break Your Savings", sub: "We compare plans across top insurers to find the right cover at the right price." },
};

export const capitalGainBondsData = {
  Icon: IconDollarSign,
  title: "Capital Gain Bonds",
  tagline: "Save capital gains tax legally while earning a safe, government-backed return.",
  intro: [
    "Capital Gain Bonds (54EC Bonds) are a powerful tax-saving tool for individuals who have earned Long-Term Capital Gains (LTCG) from the sale of property or other capital assets.",
    "By investing LTCG proceeds in 54EC bonds within 6 months of the sale, you can legally exempt the entire gain from taxation — saving lakhs in taxes.",
    "These bonds are issued by government-backed entities like NHAI, REC, and PFC — making them one of the safest fixed-income instruments available.",
  ],
  reasons: [
    { label: "Complete Tax Exemption", desc: "Legally save 20% LTCG tax on the amount invested (up to ₹50 lakhs/year)." },
    { label: "Government-Backed Safety",desc: "Issued by NHAI, REC, PFC — among India's most secure institutions." },
    { label: "Fixed Interest Rate",    desc: "Earn a fixed, guaranteed return over the 5-year lock-in period." },
    { label: "No Credit Risk",         desc: "Sovereign backing ensures timely interest payments and capital repayment." },
    { label: "Easy Process",           desc: "Simple application — we handle all documentation for you." },
  ],
  cta: { heading: "Save Your Capital Gains Tax", sub: "Sold a property recently? Invest in 54EC bonds before the 6-month deadline." },
};

export const rbiBondsData = {
  Icon: IconBank,
  title: "RBI Bonds",
  tagline: "The safest investment in India — directly backed by the Government of India.",
  intro: [
    "RBI Floating Rate Savings Bonds are direct obligations of the Government of India — the highest possible credit quality available to any investor.",
    "These bonds offer a floating interest rate linked to the NSC rate, providing protection against inflation while maintaining absolute security.",
    "RBI Bonds are ideal for conservative investors — retirees and senior citizens who cannot afford any credit risk but want a competitive return.",
  ],
  reasons: [
    { label: "Sovereign Safety",      desc: "Backed by the full faith and credit of the Government of India — zero default risk." },
    { label: "Floating Rate",         desc: "Rate adjusts with NSC, providing a hedge against falling interest rates." },
    { label: "Accessible Investment", desc: "Minimum investment of just ₹1,000 — available to all Indian residents." },
    { label: "Regular Income",        desc: "Half-yearly interest payout option for income-seeking investors." },
    { label: "Easy Redemption",       desc: "Premature redemption available for senior citizens after a specified period." },
  ],
  cta: { heading: "Invest in India's Safest Bonds", sub: "Contact us to see how RBI Bonds fit into your overall investment and tax plan." },
};

export const physicalSharesData = {
  Icon: IconFileText,
  title: "Physical Shares",
  tagline: "Convert your old physical share certificates into electronic form — hassle-free.",
  intro: [
    "Millions of Indians hold old physical share certificates that have never been dematerialised. These may represent significant forgotten wealth.",
    "AVS provides end-to-end assistance in converting physical share certificates into Demat form, enabling you to sell or hold them electronically.",
    "Our team handles complex cases including merged/renamed companies, lost certificates, and transmission of shares due to death.",
  ],
  reasons: [
    { label: "Full Documentation Support", desc: "We handle all DRF filings and correspondence with companies." },
    { label: "Complex Cases Handled",      desc: "Experience with merged entities, name changes, and transmission cases." },
    { label: "Unlock Forgotten Value",     desc: "Old shares may have split or given bonuses — discover their current value." },
    { label: "Safe & Legal Process",       desc: "All conversions follow SEBI, NSDL, and CDSL guidelines exactly." },
    { label: "Active Tracking",            desc: "We track the process and keep you updated at every step." },
  ],
  cta: { heading: "Convert Your Physical Shares Today", sub: "Those old certificates could be worth more than you think. Let's find out." },
};

export const iepfData = {
  Icon: IconScale,
  title: "Shares Transferred to IEPF",
  tagline: "Reclaim your shares and dividends transferred to the government — we guide you through every step.",
  intro: [
    "If dividends on your shares were unclaimed for 7 consecutive years, SEBI regulations require the company to transfer both dividends and shares to the Investor Education and Protection Fund (IEPF).",
    "This does not mean you've lost your shares — they can be reclaimed, but the process requires filing Form IEPF-5 and coordinating with the company's Nodal Officer.",
    "AVS has successfully helped many investors reclaim their IEPF shares and dividends. We manage the entire process — from document preparation to final credit to your Demat account.",
  ],
  reasons: [
    { label: "Expert Process Management", desc: "We handle the complex IEPF-5 filing, corporate coordination, and MCA follow-up." },
    { label: "Document Preparation",      desc: "Full assistance with Aadhaar, PAN, Demat details, and affidavits." },
    { label: "Company Liaison",           desc: "We coordinate directly with the company's Nodal Officer on your behalf." },
    { label: "Dividend Recovery",         desc: "Reclaim not just shares but all accumulated unclaimed dividends." },
    { label: "Status Updates",            desc: "Transparent communication at every stage of the recovery process." },
  ],
  cta: { heading: "Reclaim Your IEPF Shares", sub: "Your shares belong to you. Let us help you navigate the process and get them back." },
};

export const generalInsuranceData = {
  Icon: IconActivity,
  title: "General Insurance",
  tagline: "Protect your assets — home, vehicle, and valuables — with comprehensive general insurance.",
  intro: [
    "General insurance covers a wide range of non-life assets including your motor vehicle, home, shop, office, and other valuables against risks like theft, fire, accidents, and natural calamities.",
    "At AVS, we help you identify the right coverage across motor, home, fire, marine, and commercial insurance from India's leading general insurers.",
    "We compare policies across insurers to ensure you get maximum coverage at the most competitive premium, with a smooth claims process when you need it most.",
  ],
  reasons: [
    { label: "Motor Insurance",   desc: "Comprehensive and third-party policies for cars, bikes, and commercial vehicles." },
    { label: "Home Insurance",    desc: "Protect your home's structure and contents against fire, flood, theft, and more." },
    { label: "Fire & Burglary",   desc: "Coverage for shops, offices, and commercial establishments against property risks." },
    { label: "Cashless Claims",   desc: "Large network of garages and surveyors for fast, cashless claim settlement." },
    { label: "Policy Comparison", desc: "We compare across insurers so you always get the best coverage at the right price." },
  ],
  cta: { heading: "Protect What Matters Most", sub: "Get a free quote on motor, home, or commercial insurance tailored to your needs." },
};

export const npsData = {
  Icon: IconPiggyBank,
  title: "NPS / PPF",
  tagline: "Build a tax-efficient retirement corpus with government-backed long-term savings schemes.",
  intro: [
    "The National Pension System (NPS) and Public Provident Fund (PPF) are two of India's most powerful long-term, tax-efficient savings instruments, ideal for building a secure retirement corpus.",
    "NPS offers market-linked returns with equity exposure, while PPF provides a guaranteed, tax-free return backed by the Government of India — together they form a well-rounded retirement strategy.",
    "AVS guides you through account opening, contribution planning, fund selection under NPS, and helps you structure withdrawals and annuity choices at maturity.",
  ],
  reasons: [
    { label: "Triple Tax Benefit",    desc: "NPS contributions qualify under 80C plus an additional ₹50,000 deduction under 80CCD(1B)." },
    { label: "PPF Tax-Free Returns",  desc: "PPF interest and maturity proceeds are fully exempt from income tax." },
    { label: "Government Backing",    desc: "Both schemes are regulated and backed by the Government of India — zero default risk." },
    { label: "Flexible Contributions",desc: "Start NPS with as little as ₹500/month and PPF with ₹500/year." },
    { label: "Retirement Planning",   desc: "We help you calculate the corpus needed and the right monthly contribution to get there." },
  ],
  cta: { heading: "Start Building Your Retirement Corpus", sub: "The earlier you start, the more compound interest works in your favour." },
};

export const loansData = {
  Icon: IconCreditCard,
  title: "Loans",
  tagline: "Access the right loan at the right rate — home, business, personal, or loan against securities.",
  intro: [
    "Whether you need a home loan, business loan, personal loan, or a loan against your existing investments, AVS connects you with the right lending institution at competitive interest rates.",
    "We work with leading banks and NBFCs to help you navigate the loan application process — from documentation to disbursement — minimising paperwork and maximising your approval chances.",
    "For investors, we also facilitate Loan Against Mutual Funds (LAMF) and Loan Against Securities (LAS), allowing you to unlock liquidity without disrupting your investment portfolio.",
  ],
  reasons: [
    { label: "Home Loans",              desc: "Competitive rates from leading banks with expert guidance on eligibility and documentation." },
    { label: "Business Loans",          desc: "Working capital and term loans for SMEs and professionals through our banking partners." },
    { label: "Loan Against Mutual Funds",desc: "Get instant liquidity against your mutual fund portfolio without redeeming your investments." },
    { label: "Personal Loans",          desc: "Quick disbursal personal loans for medical, education, travel, or other needs." },
    { label: "End-to-End Assistance",   desc: "We handle the comparison, application, and follow-up so you don't have to." },
  ],
  cta: { heading: "Find the Right Loan for Your Needs", sub: "Talk to us before you apply anywhere — the right guidance can save you lakhs in interest." },
};